import { useMutation } from "@tanstack/react-query";
import { post } from "api/api-methods";
import { useBookingId } from "hooks/use-booking-id";

export const useRefreshBooking = () => {
    const bookingId = useBookingId();

    const refreshBooking = async () => {
        if (!bookingId) return;
        await post(`WebBooking/WebBookings/${bookingId}/Refresh`, {});
    };

    return useMutation({
        mutationFn: refreshBooking,
        scope: {
            id: "webbooking-create",
        },
    });
};
